import {IS_SINGLE_PLAYER_VALUE} from "data/constants";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {IRoundsStore} from "data/stores/rounds/rounds.store";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {action, makeAutoObservable, observable} from "mobx";

export interface IPlayerSlotProps {
	roundId?: number | null;
}

export interface IPlayerSlotController extends ViewController<IPlayerSlotProps> {
	get i18n(): ILocalizationStore;
	get isSinglePlayer(): boolean;

	setRoundId: (roundId: number | null) => void;
}

@injectable()
export class PlayerSlotController implements IPlayerSlotController {
	@observable _roundId?: number | null;

	constructor(
		@inject(Bindings.LocalizationStore) private _i18nStore: ILocalizationStore,
		@inject(Bindings.RoundsStore) private _roundStore: IRoundsStore
	) {
		makeAutoObservable(this);
	}

	get i18n() {
		return this._i18nStore;
	}

	get round() {
		if (!this._roundId) {
			return null;
		}

		return this._roundStore.getRoundById(this._roundId);
	}

	get isSinglePlayer() {
		return Boolean(this.round?.name.toLowerCase().includes(IS_SINGLE_PLAYER_VALUE));
	}

	setRoundId = (roundId: number | null) => {
		this._roundId = roundId;
	};

	@action init({roundId}: IPlayerSlotProps) {
		this._roundId = roundId;
	}
}
